"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbEmitter = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SbEmitterClass = /*#__PURE__*/function () {
  function SbEmitterClass() {
    _classCallCheck(this, SbEmitterClass);

    this.events = {};
  }

  _createClass(SbEmitterClass, [{
    key: "on",
    value: function on(event, listener) {
      var _this = this;

      if (_typeof(this.events[event]) !== 'object') {
        this.events[event] = [];
      }

      this.events[event].push(listener);
      return function () {
        return _this.off(event, listener);
      };
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (_typeof(this.events[event]) === 'object') {
        var idx = this.events[event].indexOf(listener);

        if (idx > -1) {
          this.events[event].splice(idx, 1);
        }
      }
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var nameSpaces = event.indexOf('.') !== -1 ? event.split('.') : [event];
      var partialNameSpace = nameSpaces[0];
      nameSpaces.forEach(function (name) {
        if (partialNameSpace !== name) {
          partialNameSpace += ".".concat(name);
        }

        if (_typeof(_this2.events[partialNameSpace]) === 'object') {
          _this2.events[partialNameSpace].forEach(function (listener) {
            return listener.apply(_this2, args);
          });
        }
      }); // If a log event is registered, emit a single event for it

      if (this.events.log) {
        this.events.log.forEach(function (listener) {
          return listener.apply(_this2, [event].concat(args));
        });
      }
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      var _this3 = this;

      var remove = this.on(event, function () {
        remove();

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        listener.apply(_this3, args);
      });
    }
  }]);

  return SbEmitterClass;
}();

var SbEmitter = new SbEmitterClass();
exports.SbEmitter = SbEmitter;
//# sourceMappingURL=sb-emitter.js.map